module.exports = __webpack_public_path__ + "media/loan_payments_calculator/cost_proj_btn_hover-0fd76369.png";